import { BeeswaxReportProperties } from '@/Enums/Report/BeeswaxReportProperties.enum';
import exportFromJSON from 'export-from-json';

export const downloadCSV = (data, name) => {
  const processedResultArray = [];
  for (const [key, value] of Object.entries(data)) {
    // Looker `fill_fields` emits a row for every day in the range, with null
    // metrics on days that had no delivery. Those are zeroes, not objects.
    if (value === null || value === undefined) {
      processedResultArray.push({
        [name]: key,
        Impressions: 0,
      });
    } else if (typeof value === 'number') {
      processedResultArray.push({
        [name]: key,
        Impressions: value,
      });
    } else {
      processedResultArray.push({
        [name]: key,
        Impressions: value.Impressions,
        Frequency: value.Frequency,
        Reach: value.Reach,
      });
    }
  }

  downloadTableCsv(processedResultArray, name);
};

export const downloadTableCsv = (data, name) => {
  exportFromJSON({
    data,
    fileName: name,
    exportType: exportFromJSON.types.csv,
  });
};

export const transformGeoToCSVData = data => {
  return data
    .map(item => ({
      name:
        item[BeeswaxReportProperties.GEO_STATE] ||
        item[BeeswaxReportProperties.DMA_NAME] ||
        item[BeeswaxReportProperties.GEO_ZIP] ||
        item[BeeswaxReportProperties.GEO_COUNTY] ||
        item[BeeswaxReportProperties.GEO_CONGRESSIONAL_DISTRICTS],
      Impressions: item.Impressions,
      Reach: item.Reach,
      Frequency: item.Frequency,
    }))
    .filter(item => item.name);
};
